module.exports = __webpack_public_path__ + "static/media/42.3040270d.mp3";